<template>
	<div>
		<details-page-gen :options="options" />
	</div>
</template>

<script>
import DetailsPageGen from './DetailsPageGen.vue'

const config = {
	options: {
		resource: 'routes',
		display: ['clientId', 'pickupPoint', 'createdAt', 'updatedAt']
	}
}

export default {
	name: 'RouteDetails',
	components: { DetailsPageGen },
	data: () => config
}
</script>
